import './PriorityChip.scss';

interface Props {
  priorityName: string;
}

export default function PriorityChip({
  priorityName,
}: Props) {
  return (
    <div className={`PriorityChip ${priorityName.replace('_', '').replace(' ', '')}`}>
      {priorityName.replace('_', '-')}
    </div>
  );
}
